// extracted by mini-css-extract-plugin
export default {"wrapper":"RsuCwbB582VHGY3UkHuB"};